<template>
  <div class="rate-category">
    <el-row>
      <el-col :span="6" class="title-column">
        <h5>{{ category | ratingCategoryLabel }}</h5>
      </el-col>

      <el-col :span="10" class="rating-column">
        <StartupRate
          v-model="rating.value"
          :read-only="readOnly"
          @input="onRatingChange"
        />
      </el-col>

      <el-col :span="8">
        <el-button
          plain
          type="info"
          size="mini"
          @click="toggleNoteVisibility()"
        >
          <span v-if="!noteVisible">
            {{ rating.note ? 'Edit note' : 'Add note' }}
          </span>
          <span v-else>Hide note</span>
        </el-button>
      </el-col>
    </el-row>

    <el-form v-show="noteVisible" label-position="top">
      <el-form-item>
        <p v-if="readOnly">
          {{ rating.note || '-' }}
        </p>
        <el-input
          v-if="!readOnly"
          ref="noteInput"
          v-model="rating.note"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 10 }"
          placeholder="You may put your note here"
          @input="onNoteChange"
        />
      </el-form-item>
    </el-form>

    <hr v-if="isMain" />
  </div>
</template>

<script>
import StartupRate from 'components/StartupRate.vue'
import { ratingCategoryLabel } from 'services/rating-categories'

export default {
  components: { StartupRate },
  filters: { ratingCategoryLabel },
  props: {
    category: { type: String, default: () => '' },
    value: { type: Object, default: () => ({ value: 0, note: '' }) },
    readOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      noteVisible: false,
    }
  },
  computed: {
    isMain() {
      return this.category === 'overall'
    },
    rating: {
      get() {
        return this.value
      },
      set(newRating) {
        this.$emit('input', newRating)
      },
    },
  },
  methods: {
    toggleNoteVisibility() {
      this.noteVisible = !this.noteVisible
      this.$nextTick(() => {
        this.$refs.noteInput.focus()
      })
    },

    onRatingChange(val, oldVal) {
      this.$emit('input', { ...this.value, value: val })
    },
    onNoteChange(val) {
      this.$emit('input', { ...this.value, note: val })
    },
  },
}
</script>

<style lang="scss" scoped>
.rate-category {
  .title-column {
    text-align: right;
    padding-right: 10px;
  }

  .rating-column {
    padding: 9px 5px;
  }
}
</style>
